import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { faImage, faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { toast } from 'react-toastify';



const AddProject = () => {

    const [coverImage, setCoverImage] = useState('');
    const [screenshortImg1, setScreenshortImg1] = useState('');
    const [screenshortImg2, setScreenshortImg2] = useState('');
    const [screenshortImg3, setScreenshortImg3] = useState('');



    const { register, formState: { errors }, handleSubmit, reset } = useForm();
    const imgStoreKey = '1102b1b472176018cfdab59d9d885956';


    // coverPhoto
    const onSubmit = data => {
        const imges = data.coderPhoto[0];
        const formData = new FormData();
        formData.append('image', imges);

        const url = `https://api.imgbb.com/1/upload?key=${imgStoreKey}`;
        fetch(url, {
            method: 'POST',
            body: formData
        })
            .then(res => res.json())
            .then(data => {

                if (data?.success === true) {
                    setCoverImage(data?.data?.url)
                    toast.success('Cover Photo Added')
                }
                else {
                    toast.error('Failed to Cover Photo Added')
                }
            })

    }

    // screenshort1 
    const onSubmit1 = data => {
        const imges = data.screenshort1[0];
        const formData = new FormData();
        formData.append('image', imges);

        const url = `https://api.imgbb.com/1/upload?key=${imgStoreKey}`;
        fetch(url, {
            method: 'POST',
            body: formData
        })
            .then(res => res.json())
            .then(data => {
                if (data?.success === true) {
                    setScreenshortImg1(data?.data?.url)
                    toast.success('Screenshort One Added')
                }
                else {
                    toast.error('Failed to Screenshort One Added')
                }
            })

    }


    // screenshort2
    const onSubmit2 = data => {
        const imges = data.screenshort2[0];
        const formData = new FormData();
        formData.append('image', imges);

        const url = `https://api.imgbb.com/1/upload?key=${imgStoreKey}`;
        fetch(url, {
            method: 'POST',
            body: formData
        })
            .then(res => res.json())
            .then(data => {
                if (data?.success === true) {
                    setScreenshortImg2(data?.data?.url)
                    toast.success('Screenshort Two Added')
                }
                else {
                    toast.error('Failed to Screenshort Two Added')
                }

            })

    }


    // screenshort3
    const onSubmit3 = data => {
        const imges = data.screenshort3[0];
        const formData = new FormData();
        formData.append('image', imges);

        const url = `https://api.imgbb.com/1/upload?key=${imgStoreKey}`;
        fetch(url, {
            method: 'POST',
            body: formData
        })
            .then(res => res.json())
            .then(data => {
                if (data?.success === true) {
                    setScreenshortImg3(data?.data?.url)
                    toast.success('Screenshort Three Added')
                }
                else {
                    toast.error('Failed to Screenshort Three Added')
                }
            })

    }


    //  form submit 
    const onSubmitform = data => {

        const newProject = {
            name: data?.name,
            role: data?.role,
            coverImg: coverImage,
            img1: screenshortImg1,
            img2: screenshortImg2,
            img3: screenshortImg3,
            url: data?.url,
            clientSide: data?.clientSideUrl,
            serverSide: data?.serverSideUrl,
            title: data?.title,
            des: data?.des,
            point1: data?.point1,
            point2: data?.point2,
            point3: data?.point3,
            point4: data?.point4,
            point5: data?.point5,
            userd: data?.technology
        }

        fetch('https://stark-wildwood-35883.herokuapp.com/projects', {
            method: "POST",
            headers: {
                'content-type': 'application/json'
            },
            body: JSON.stringify(newProject)
        })
            .then(res => res.json())
            .then(data => {

                if (data?.acknowledged === true) {
                    toast.success('Successfully Added a New Project!!!')
                    reset()
                }
                else {
                    toast.error('failed Added a New Project!!!')
                }
            })
    }


    return (
        <div className='bg-slate-200 px-8 py-10 md:p-6 h-100'>
            <div className='grid bg-white p-4 rounded-2xl md:grid-cols-2 grid-cols-1 md:gap-6 gap-2'>
                <div>
                    <div className='grid lg:grid-cols-1  my-4 gap-2 gap-x-4'>
                        <form onSubmit={handleSubmit(onSubmit)}>
                            <div className="form-control w-full mb-2 border-2 p-2 rounded-lg custom_shadow border-green-500 ">
                                <label className="label font-bold lg:text-lg md:text-medium">Cover Photo</label>
                                <input
                                    type="file"
                                    placeholder="Project Cover Photo"
                                    className="input input-bordered w-full cursor-pointer mb-[-10px] "
                                    {...register("coderPhoto", {
                                        required: {
                                            value: true,
                                            message: "Cover Photo is required"
                                        }
                                    })}
                                />
                                <label className="label">
                                    {errors.coderPhoto?.type === 'required' && <span className="label-text-alt text-red-500 mt-2">{errors.coderPhoto.message}</span>}
                                </label>
                                <button type='submit' className='btn bg-green-500 border-0 text-white'> CoverPhoto <FontAwesomeIcon className='ml-2' icon={faImage} /> </button>
                            </div>
                        </form>

                        {/* screenshort1 */}
                        <form onSubmit={handleSubmit(onSubmit1)}>
                            <div className="form-control w-full mb-2 border-2 p-2 rounded-lg custom_shadow border-green-500 ">
                                <label className="label font-bold  lg:text-lg md:text-medium ">Screenshort One</label>
                                <input
                                    type="file"
                                    placeholder="Project Screenshort One"
                                    className="input input-bordered w-full cursor-pointer mb-[-10px] "
                                    {...register("screenshort1", {
                                        required: {
                                            value: true,
                                            message: "Screenshort One is required"
                                        }
                                    })}
                                />
                                <label className="label">
                                    {errors.screenshort1?.type === 'required' && <span className="label-text-alt text-red-500 mt-2">{errors.screenshort1.message}</span>}
                                </label>
                                <button type='submit' className='btn bg-green-500 border-0 text-white'>ScreenshortOne <FontAwesomeIcon className='ml-2' icon={faImage} /></button>
                            </div>
                        </form>

                        {/* screenshort2 */}
                        <form onSubmit={handleSubmit(onSubmit2)}>
                            <div className="form-control w-full mb-2 border-2 p-2 rounded-lg custom_shadow border-green-500 ">
                                <label className="label font-bold  lg:text-lg md:text-medium">Screenshort Two</label>
                                <input
                                    type="file"
                                    placeholder="Project Screenshort Two"
                                    className="input input-bordered w-full cursor-pointer  mb-[-10px]"
                                    {...register("screenshort2", {
                                        required: {
                                            value: true,
                                            message: "Screenshort Two is required"
                                        }
                                    })}
                                />
                                <label className="label">
                                    {errors.screenshort2?.type === 'required' && <span className="label-text-alt text-red-500 mt-2">{errors.screenshort2.message}</span>}
                                </label>
                                <button type='submit' className='btn bg-green-500 border-0 text-white'>ScreenshortTwo <FontAwesomeIcon className='ml-2' icon={faImage} /></button>
                            </div>
                        </form>

                        {/* screenshort3 */}
                        <form onSubmit={handleSubmit(onSubmit3)}>
                            <div className="form-control w-full  mb-2 border-2 p-2 rounded-lg custom_shadow border-green-500 ">
                                <label className="label font-bold lg:text-lg md:text-medium ">Screenshort Three</label>
                                <input
                                    type="file"
                                    placeholder="Project Screenshort Three"
                                    className="input input-bordered w-full cursor-pointer mb-[-10px] "
                                    {...register("screenshort3", {
                                        required: {
                                            value: true,
                                            message: " Screenshort Three is required"
                                        }
                                    })}
                                />
                                <label className="label">
                                    {errors.screenshort3?.type === 'required' && <span className="label-text-alt text-red-500 mt-2">{errors.screenshort3.message}</span>}
                                </label>
                                <button type='submit' className='btn bg-green-500 border-0 text-white'>ScreenshortThree <FontAwesomeIcon className='ml-2' icon={faImage} /></button>
                            </div>
                        </form>
                    </div>
                </div>
                <div className='text-2xl my-4 '>
                    <form onSubmit={handleSubmit(onSubmitform)}>
                        <div className="form-control w-full mb-2 border-2 p-2 rounded-lg custom_shadow border-green-500 ">
                            <input
                                type="text"
                                placeholder="Project Name"
                                className="input input-bordered w-full "
                                {...register("name", {
                                    required: {
                                        value: true,
                                        message: "Name is required"
                                    }
                                })}
                            />
                            <label className="label">
                                {errors.name?.type === 'required' && <span className="label-text-alt text-red-500  ">{errors.name?.message}</span>}
                            </label>


                            <input
                                type="text"
                                placeholder="Project Title"
                                className="input input-bordered w-full "
                                {...register("title", {
                                    required: {
                                        value: true,
                                        message: "Title is required"
                                    }
                                })}
                            />
                            <label className="label">
                                {errors.title?.type === 'required' && <span className="label-text-alt text-red-500  ">{errors.title?.message}</span>}
                            </label>

                            <input
                                type="text"
                                placeholder="Project Role (webdesign/mern/photograpy)"
                                className="input input-bordered w-full "
                                {...register("role", {
                                    required: {
                                        value: true,
                                        message: "Role is required"
                                    }
                                })}
                            />
                            <label className="label">
                                {errors.role?.type === 'required' && <span className="label-text-alt text-red-500 ">{errors.role?.message}</span>}
                            </label>


                            <input
                                type="url"
                                placeholder="Project Live URL"
                                className="input input-bordered w-full "
                                {...register("url", {
                                    required: {
                                        value: true,
                                        message: "Url is required"
                                    }
                                })}
                            />
                            <label className="label">
                                {errors.url?.type === 'required' && <span className="label-text-alt text-red-500  ">{errors.url?.message}</span>}
                            </label>

                            <input
                                type="url"
                                placeholder="Client-Side Code URL"
                                className="input input-bordered  w-full "
                                {...register("clientSideUrl", {
                                    required: {
                                        value: true,
                                        message: "Client-Side Code Url is required"
                                    }
                                })}
                            />
                            <label className="label">
                                {errors.slientSideUrl?.type === 'required' && <span className="label-text-alt text-red-500  ">{errors.slientSideUrl?.message}</span>}
                            </label>

                            <input
                                type="url"
                                placeholder="Server-Side Code URL"
                                className="input input-bordered mb-4 w-full "
                                {...register("serverSideUrl")}
                            />

                            <textarea
                                type="text"
                                placeholder="Bullet Point One"
                                style={{ resize: 'none' }}
                                className="textarea textarea-bordered"
                                {...register("point1", {
                                    required: {
                                        value: true,
                                        message: "Bullet Point One is required"
                                    }
                                })}
                            />
                            <label className="label">
                                {errors.point1?.type === 'required' && <span className="label-text-alt text-red-500  ">{errors.point1?.message}</span>}
                            </label>

                            <textarea
                                type="text"
                                placeholder="Bullet Point Two"
                                style={{ resize: 'none' }}
                                className="textarea textarea-bordered"
                                {...register("point2", {
                                    required: {
                                        value: true,
                                        message: "Bullet Point Two is required"
                                    }
                                })}
                            />
                            <label className="label">
                                {errors.point2?.type === 'required' && <span className="label-text-alt text-red-500  ">{errors.point2?.message}</span>}
                            </label>

                            <textarea
                                type="text"
                                placeholder="Bullet Point Three"
                                style={{ resize: 'none' }}
                                className="textarea textarea-bordered"
                                {...register("point3", {
                                    required: {
                                        value: true,
                                        message: "Bullet Point Three is required"
                                    }
                                })}
                            />
                            <label className="label">
                                {errors.point3?.type === 'required' && <span className="label-text-alt text-red-500  ">{errors.point3?.message}</span>}
                            </label>

                            <textarea
                                type="text"
                                placeholder="Bullet Point  Four"
                                style={{ resize: 'none' }}
                                className="textarea textarea-bordered mb-4"
                                {...register("point4")}
                            />


                            <textarea
                                type="text"
                                placeholder="Bullet Point Five"
                                style={{ resize: 'none' }}
                                className="textarea textarea-bordered mb-4"
                                {...register("point5")}
                            />

                            <textarea
                                type="text"
                                placeholder="Technologies Used"
                                style={{ resize: 'none' }}
                                className="textarea textarea-bordered"
                                {...register("technology", {
                                    required: {
                                        value: true,
                                        message: "Technologies Used is required"
                                    }
                                })}
                            />
                            <label className="label">
                                {errors.technology?.type === 'required' && <span className="label-text-alt text-red-500  ">{errors.technology?.message}</span>}
                            </label>

                            <textarea
                                type="text"
                                placeholder="Description"
                                style={{ resize: 'none' }}
                                className="textarea textarea-bordered"
                                {...register("des", {
                                    required: {
                                        value: true,
                                        message: "Description  is required"
                                    }
                                })}
                            />
                            <label className="label">
                                {errors.des?.type === 'required' && <span className="label-text-alt text-red-500">{errors.des?.message}</span>}
                            </label>
                            <button type='submit' className='btn custom_shadow bg-green-500  border-2 border-blue-500 text-white  '> Add New Project  <FontAwesomeIcon className='ml-2 rounded-full bg-blue-500  p-2' icon={faArrowRight} /></button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default AddProject;